export const API_URL = 'https://api.valparx.com/';